import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table", "tbody"]
  
  connect() {
    this.sortColumn = null
    this.sortDirection = 'asc'
    
    // Add click handlers to sortable headers
    this.element.querySelectorAll('th[data-sort-column]').forEach(th => {
      th.addEventListener('click', (e) => this.sort(e))
    })
  }
  
  sort(event) {
    const th = event.currentTarget
    const column = th.dataset.sortColumn
    
    // Toggle sort direction if clicking same column
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
    } else {
      this.sortColumn = column
      this.sortDirection = 'asc'
    }
    
    // Update header indicators
    this.updateHeaders(th)
    
    // Get all rows and sort them
    const rows = Array.from(this.tbodyTarget.querySelectorAll('tr'))
    const sortedRows = rows.sort((a, b) => {
      const aValue = a.dataset[column] || ''
      const bValue = b.dataset[column] || ''
      
      // Handle numeric vs string sorting
      const aNum = parseFloat(aValue)
      const bNum = parseFloat(bValue)
      
      let comparison = 0
      if (!isNaN(aNum) && !isNaN(bNum)) {
        comparison = aNum - bNum
      } else {
        comparison = aValue.localeCompare(bValue)
      }
      
      return this.sortDirection === 'asc' ? comparison : -comparison
    })
    
    // Clear tbody and re-append sorted rows
    this.tbodyTarget.innerHTML = ''
    sortedRows.forEach(row => this.tbodyTarget.appendChild(row))
  }
  
  updateHeaders(activeHeader) {
    // Reset all headers
    this.element.querySelectorAll('th[data-sort-column]').forEach(th => {
      const svg = th.querySelector('svg')
      svg.classList.remove('text-gray-900', 'rotate-180')
      svg.classList.add('text-gray-400')
    })
    
    // Update active header
    const svg = activeHeader.querySelector('svg')
    svg.classList.remove('text-gray-400')
    svg.classList.add('text-gray-900')
    
    if (this.sortDirection === 'desc') {
      svg.classList.add('rotate-180')
    }
  }
}